'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'blockchains';
const BLOCKCHAIN_ERROR = 'blockchain';
exports.Abbreviations = void 0;
(function(Abbreviations) {
    Abbreviations["ALGO"] = "ALGO";
    Abbreviations["APTOS"] = "APTOS";
    Abbreviations["ARB"] = "ARB";
    Abbreviations["ARC"] = "ARC";
    Abbreviations["AVAX"] = "AVAX";
    Abbreviations["BASE"] = "BASE";
    Abbreviations["BTC"] = "BTC";
    Abbreviations["CELO"] = "CELO";
    Abbreviations["CODEX"] = "CODEX";
    Abbreviations["CORE"] = "CORE";
    Abbreviations["ETH"] = "ETH";
    Abbreviations["EVMOS"] = "EVMOS";
    Abbreviations["FLOW"] = "FLOW";
    Abbreviations["HBAR"] = "HBAR";
    Abbreviations["HYPEREVM"] = "HYPEREVM";
    Abbreviations["INK"] = "INK";
    Abbreviations["LINEA"] = "LINEA";
    Abbreviations["MANA"] = "MANA";
    Abbreviations["MATIC"] = "MATIC";
    Abbreviations["MONAD"] = "MONAD";
    Abbreviations["NEAR"] = "NEAR";
    Abbreviations["NOBLE"] = "NOBLE";
    Abbreviations["OP"] = "OP";
    Abbreviations["PAH"] = "PAH";
    Abbreviations["PLUME"] = "PLUME";
    Abbreviations["POLY"] = "POLY";
    Abbreviations["SEI"] = "SEI";
    Abbreviations["SETTLUS"] = "SETTLUS";
    Abbreviations["SOL"] = "SOL";
    Abbreviations["SONIC"] = "SONIC";
    Abbreviations["SUI"] = "SUI";
    Abbreviations["TRX"] = "TRX";
    Abbreviations["UNI"] = "UNI";
    Abbreviations["WORLDCHAIN"] = "WORLDCHAIN";
    Abbreviations["XDC"] = "XDC";
    Abbreviations["XLM"] = "XLM";
    Abbreviations["XRP"] = "XRP";
    Abbreviations["ZKS"] = "ZKS";
})(exports.Abbreviations || (exports.Abbreviations = {}));
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    const error = options?.error ?? `${BLOCKCHAIN_ERROR}.${options?.abbreviation ?? 'default'}`;
    switch(options?.abbreviation){
        case 'ARB':
        case 'ARC':
        case 'AVAX':
        case 'BASE':
        case 'CELO':
        case 'CODEX':
        case 'ETH':
        case 'EVMOS':
        case 'LINEA':
        case 'MANA':
        case 'MATIC':
        case 'OP':
        case 'SETTLUS':
        case 'SONIC':
        case 'UNI':
        case 'ZKS':
        case 'POLY':
        case 'WORLDCHAIN':
        case 'SEI':
        case 'MONAD':
        case 'XDC':
        case 'HYPEREVM':
        case 'CORE':
        case 'INK':
        case 'PLUME':
            return this.ethereum({
                error
            });
        case 'ALGO':
            return this.algorand({
                error
            });
        case 'APTOS':
            return this.aptos({
                error
            });
        case 'FLOW':
            return this.flow({
                error
            });
        case 'HBAR':
            return this.hedera({
                error
            });
        case 'NEAR':
            return this.near({
                error
            });
        case 'NOBLE':
            return this.noble({
                error
            });
        case 'SOL':
            return this.solana({
                error
            });
        case 'SUI':
            return this.sui({
                error
            });
        case 'PAH':
            return this.statemint({
                error
            });
        case 'TRX':
            return this.tron({
                error
            });
        case 'XLM':
            return this.stellar({
                error
            });
        case 'XRP':
            return this.ripple({
                error
            });
        case 'BTC':
            return this.bitcoin({
                error
            });
        case undefined:
            return this.test({
                name,
                message: {
                    key: error
                },
                test: ()=>{
                    return false;
                }
            });
    }
});

exports.BLOCKCHAIN_ERROR = BLOCKCHAIN_ERROR;
//# sourceMappingURL=blockchains.js.map
